import { render, staticRenderFns } from "./postFiles.vue?vue&type=template&id=8bb9b39a&scoped=true&"
import script from "./postFiles.vue?vue&type=script&lang=js&"
export * from "./postFiles.vue?vue&type=script&lang=js&"
import style0 from "./postFiles.vue?vue&type=style&index=0&id=8bb9b39a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb9b39a",
  null
  
)

export default component.exports